import { configureStore } from '@reduxjs/toolkit';

import form from './form';

export const store = configureStore({
    reducer: {
        form
    }
});
